import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}
const paddingStyles = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6'
};
export function Card({
  children,
  className = '',
  padding = 'md'
}: CardProps) {
  return <div className={`
        bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-lg shadow-sm
        ${paddingStyles[padding]}
        ${className}
      `} data-id="element-615">
      {children}
    </div>;
}
interface CardHeaderProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
}
export function CardHeader({
  title,
  description,
  action
}: CardHeaderProps) {
  return <div className="flex items-start justify-between mb-4" data-id="element-616">
      <div data-id="element-617">
        <h3 className="text-sm font-semibold text-slate-900 dark:text-slate-100" data-id="element-618">
          {title}
        </h3>
        {description && <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5" data-id="element-619">
            {description}
          </p>}
      </div>
      {action && <div data-id="element-620">{action}</div>}
    </div>;
}